import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AppBar, Form } from './components';
import blue from '@mui/material/colors/blue';
import red from '@mui/material/colors/red';
import './App.css';
import { Paper, Typography } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: blue,
    secondary: red,
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppBar />
      {/*<Form />*/}

      {/* User message */}
      <Paper style={{ position: 'absolute', left: '50%', top: '50%', padding: 20, transform: 'translate(-50%, -50%)' }} elevation={1}>
        <Typography align="center" variant="h6">
          Eine Online-Anmeldung zum diesjährigen Seniorennachmittag ist nicht mehr möglich. Bitte melden Sie sich telefonisch zu den üblichen Öffnungszeiten des Rathauses unter der Tel.-Nr. 9356-100
        </Typography>
      </Paper>
    </ThemeProvider>
  );
}
